var constants = require('../constants');
var utils = require('../utils');
var fetchActions = require('./surveys-fetch');

var updateSurveyProgress = (function() {

    var _updateSurveyProgress = function() {
        return function(dispatch, getState){
            dispatch(fetchActions.fetchSurveysIfNeeded(getState().surveys.index.join(), getState().auth.token)).then(function() {
                var state = getState();
                var surveyArray = state.surveys.index;
                var oldProgress = state.surveys.progress;
                var surveys = state.entities.surveys;
                const surveyType = state.surveys.surveyType;
                
                if (surveyType === 'nhs2') {
                    // Set progress bar based on specific question numbers
                    // Q3 / Q25 / Q33 / Q53
                    var history = state.surveys;
                    var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);
                    var sequenceId = utils.getSequenceId(surveys, surveyId, history.currentSequenceIndex);
                    var currentField = utils.getCurrentField(state.entities.fields, sequenceId);
                    var questionNumber = currentField.name.replace('Q', '');
                    var newProgress = 0;

                    switch (questionNumber) {
                        case '3':
                            newProgress = 25;
                            break;
                        case '25':
                            newProgress = 50;
                            break;
                        case '33':
                            newProgress = 75;
                            break;
                        case '53':
                            newProgress = 100;
                            break;  
                        default:
                            newProgress = 0;
                    }
                } else {
                    var answeredQuestionsOffset = 0;
                    for(var i = 0; i < state.surveys.currentSurveyIndex; i++){
                        answeredQuestionsOffset += utils.getSequenceLength(surveys, surveyArray[i]);
                    }
                    answeredQuestionsOffset += state.surveys.currentSequenceIndex;

                    var totalQuestionsNum = 0;
                    surveyArray.forEach(function(surveyId){
                        totalQuestionsNum += utils.getSequenceLength(surveys, surveyId);
                    });

                    newProgress = Math.round(answeredQuestionsOffset/totalQuestionsNum*100);    
                }

                var finalProgress = Math.max(oldProgress, newProgress);

                dispatch({
                    type: constants.UPDATE_SURVEY_PROGRESS,
                    progress: finalProgress
                });
            });
        };
    }

    return {
        updateSurveyProgress: _updateSurveyProgress
    }
})();

module.exports = updateSurveyProgress;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-update-progress.js